import { Coins, Star, Zap } from 'lucide-react';
import { CREDIT_PACKS, CREDIT_USES } from '../../config/pricing';
import { SectionHeader, Cta } from '../common';
import { EXT, openExternal } from '../../config/links';

export default function KalkiCredits() {
  return (
    <section className="section" style={{ background: 'var(--bg-2)', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)' }}>
      <div className="container-x">
        <div className="reveal"><SectionHeader eyebrow="Kalki Credits" title="Simple credits that power the platform." sub="Included with every subscription and available as one-time top-ups. No tokens, no complexity — just credits." /></div>
        <div className="flex flex-wrap gap-2 mt-6 reveal">
          {CREDIT_USES.map((u) => <span key={u} className="chip" style={{ color: 'var(--gold-2)', borderColor: 'var(--gold-border)' }}>{u}</span>)}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-10">
          {CREDIT_PACKS.map((c, i) => (
            <div key={c.credits} className="panel panel-hover p-6 reveal flex items-center justify-between" style={{ transitionDelay: `${(i % 3) * 50}ms`, borderColor: c.best ? 'var(--gold-border)' : 'var(--border)', background: c.best ? 'linear-gradient(180deg, rgba(214,179,106,0.05), var(--surface) 45%)' : 'var(--surface)' }}>
              <div>
                <div className="flex items-center gap-2"><Coins size={16} className="text-[var(--gold-2)]" /><span className="font-mono text-[15px] text-white">{c.credits} Credits</span>{c.best && <span className="tag"><Star size={10} /> Best</span>}</div>
                <div className="font-mono text-[11px] text-[var(--muted-2)] mt-1.5">≈ {c.rate}</div>
              </div>
              <div className="text-right">
                <div className="font-display text-[24px] font-bold text-white leading-none">{c.price}</div>
                <Cta size="sm" variant={c.best ? 'gold' : 'outline'} className="mt-2.5" href={EXT.COINS} onClick={() => openExternal(EXT.COINS, 'coin_purchase_click')}><Zap size={13} /> Top up</Cta>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
